import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import Event from '@mui/icons-material/Event';
import PlayCircleOutline from '@mui/icons-material/PlayCircleOutline';

import { Typo } from 'uikit/content';
import { CardMeta } from 'uikit/cards';

import { getSanitizedDescription } from '@/exceed';

import getCoverArtUrl from '../helpers/getCoverArtUrl';
import getMyVideosDateTimeString from '../helpers/getMyVideosDateTimeString';

import VideoLiveAndUpcomingCardIndicator from './videoLiveAndUpcomingCardIndicator';

import styles from '../styles/myVideosListItem.module.scss';

const VideosInfiniteListItem = ({
  id,
  name,
  description,
  start_at: startAt,
  end_at: endAt,
  type,
  cover_art: coverArt,
}) => {
  const urlTypeParam = type === 'video' ? 'on-demand' : 'live';
  const coverArtUrl = getCoverArtUrl(coverArt);

  return (
    <Link className={styles.item} to={`/student/videos/${urlTypeParam}/${id}`} key={`videos-${id}`}>
      <div
        className={classnames(styles.cover_art, {
          [styles[`default-${type}`]]: !coverArtUrl,
        })}
      >
        {coverArtUrl && <img src={coverArtUrl} alt="" />}
        <PlayCircleOutline className={styles.playIcon} sx={{ height: 44, width: 44 }} />
      </div>
      <div className={styles.content}>
        <Typo className={`${styles.title} ${styles.content_title}`} variant="d01">
          {name}
        </Typo>
        <Typo
          className={styles.description}
          variant="b02"
          dangerouslySetInnerHTML={{
            __html: getSanitizedDescription({ html: description }),
          }}
        />
        <div className={styles.meta}>
          {type === 'live_video' && (
            <VideoLiveAndUpcomingCardIndicator
              className={styles.liveIndicator}
              startAt={startAt}
              endAt={endAt}
            />
          )}
          {startAt && (
            <CardMeta
              className={styles.cardMeta}
              icon={<Event />}
              text={getMyVideosDateTimeString({ date: startAt })}
              modifier={null}
            />
          )}
        </div>
      </div>
    </Link>
  );
};

VideosInfiniteListItem.defaultProps = {};

VideosInfiniteListItem.propTypes = {};

export default React.memo(VideosInfiniteListItem);
